import { render, staticRenderFns } from "./perks.vue?vue&type=template&id=2d77758b&scoped=true"
import script from "./perks.vue?vue&type=script&lang=js"
export * from "./perks.vue?vue&type=script&lang=js"
import style0 from "./perks.vue?vue&type=style&index=0&id=2d77758b&prod&scoped=true&style=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77758b",
  null
  
)

export default component.exports